import axios from 'axios'
import { BECOME_PARTNER } from '@store/types'


const actions = {
  [BECOME_PARTNER]: async ({ }, payload) => {
    try {
      const formData = new FormData()

      Object.keys(payload)
        .filter(key => (typeof payload[key] !== 'undefined') && (typeof payload[key] !== 'object' || !!payload[key]))
        .forEach(key => formData.append(key, payload[key]))

      const { data: { success } } = await axios.post('request-partners', formData)
      return success
    } catch (error) {
      return error
    }
  }
}

export default { actions }



// WEBPACK FOOTER //
// ./src/store/modules/becomePartner.js